import { Box, Typography, Grid2, Divider, Button } from "@mui/material";
import { useState } from "react";
import Card from "./Card";
import DatePicker from "./DatePicker";

const typeTranslates = [
    { en: "maleAnimal", gr: "Κριός" },
    { en: "femaleAnimal", gr: "Προβατίνα" },
    { en: "lamb", gr: "Αμνός" },
];

const OrderDetailsCard = ({ order, onExecuteOrder, orderNumber }) => {
    const [executionDate, setExecutionDate] = useState(null);

    const handleExecuteOrder = () => {
        console.log("Order", order)
        if (executionDate) {
            onExecuteOrder(executionDate, orderNumber);
        } else {
            alert("Παρακαλώ εισάγετε μια ημερομηνία εκτέλεσης.");
        }
    };

    if (!order) {
        return (
            <Card
                title="Λεπτομέρειες Παραγγελίας"
                titleBackgroundColor="primary"
                titleColor="white.main"
                backgroundColor="white.main"
                footerExists={false}
            >
                <Typography variant="body1" color="error">
                    Δεν υπάρχουν διαθέσιμες πληροφορίες για την παραγγελία.
                </Typography>
            </Card>
        );
    }

    return (
        <Card
            title="Λεπτομέρειες Παραγγελίας"
            titleBackgroundColor="primary"
            titleColor="white.main"
            backgroundColor="white.main"
            footer={`Κατάσταση: ${order.executionDate ? "Εκτελέστηκε" : "Σε εκκρεμότητα"}`}
            footerBackgroundColor="secondary"
            footerColor="white.main"
        >
            <Grid2 container spacing={2}>
                <Grid2 item xs={6}>
                    <Box>
                        <Typography variant="body1">
                            <strong>Αγοραστής:</strong> {order.buyer}
                        </Typography>
                        <Typography variant="body1">
                            <strong>Όνομα:</strong> {order.buyerFirstName}
                        </Typography>
                        <Typography variant="body1">
                            <strong>Επώνυμο:</strong> {order.buyerLastName}
                        </Typography>
                        <Typography variant="body1">
                            <strong>Πόλη:</strong> {order.city}
                        </Typography>
                        <Typography variant="body1">
                            <strong>Τηλέφωνο:</strong> {order.phoneNumber || ""}
                        </Typography>
                    </Box>
                </Grid2>

                <Grid2 item xs={6}>
                    <Box>
                        <Typography variant="body1">
                            <strong>Πωλητής:</strong> {order.seller}
                        </Typography>
                        <Typography variant="body1">
                            <strong>Ημερομηνία Παραγγελίας:</strong>{" "}
                            {new Date(order.orderDate).toLocaleDateString("el-GR")}
                        </Typography>
                        {order.executionDate && (
                            <Typography variant="body1">
                                <strong>Ημερομηνία Εκτέλεσης:</strong>{" "}
                                {new Date(order.executionDate).toLocaleDateString("el-GR")}
                            </Typography>
                        )}
                    </Box>
                </Grid2>
            </Grid2>

            {!order.executionDate && (
                <Box mt={4} mb={2} sx={{width:"50%"}}>
                    <Typography variant="h6" gutterBottom>
                        Εκτέλεση Παραγγελίας
                    </Typography>
                    <Grid2 container spacing={2} alignItems="center">
                        <Grid2 item xs={8}>
                            <DatePicker
                                type="desktop"
                                label="Ημερομηνία εκτέλεσης παραγγελίας"
                                value={executionDate}
                                onChange={(newValue) => setExecutionDate(newValue)}
                                required
                            />
                        </Grid2>
                        <Grid2 item xs={4}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={handleExecuteOrder}
                            >
                                Εκτέλεση παραγγελίας
                            </Button>
                        </Grid2>
                    </Grid2>
                </Box>
            )}

            <Box mt={4}>
                <Typography variant="h6" gutterBottom>
                    Ζώα στην Παραγγελία
                </Typography>
                <Divider />
                {order.orderAnimals.length > 0 ? (
                    order.orderAnimals.map((animal) => (
                        <Box key={animal._id} mt={2} p={2} border={1} borderColor="grey.300" borderRadius={2}>
                            <Typography variant="body1">
                                <strong>Τύπος Ζώου:</strong>{" "}
                                {typeTranslates.find((translate) => translate.en === animal.type)?.gr}
                            </Typography>
                            <Typography variant="body1">
                                <strong>Κωδικός Ζώου:</strong> {animal.code}
                            </Typography>
                            {animal.lambFlockCode && (
                                <Typography variant="body1">
                                    <strong>Κωδικός στην νέα Εκτροφή:</strong> {animal.lambFlockCode}
                                </Typography>
                            )}
                            <Typography variant="body1">
                                <strong>Αξία Παραγγελίας:</strong> {animal.orderValue}€
                            </Typography>
                        </Box>
                    ))
                ) : (
                    <Typography variant="body2" color="textSecondary">
                        Δεν υπάρχουν ζώα σε αυτήν την παραγγελία.
                    </Typography>
                )}
            </Box>
        </Card>
    );
};

export default OrderDetailsCard;
